import React, { useEffect, useRef, useState } from 'react';
import { G } from './Reveal';

const projectFlow = [
  'Business describes a need',
  'Structured discovery',
  'AI-assisted draft scope',
  'Human review and confirmation',
  'Required capabilities identified',
  'Suitable professionals / internal team identified',
  'Project structure and milestones created',
  'Delivery begins',
  'Evidence, blockers and changes recorded',
  'Customer reviews milestone',
  'Accepted / revised / escalated',
  'Project knowledge retained',
];

const useScrollFill = (ref) => {
  const [p, setP] = useState(0);
  useEffect(() => {
    let raf = 0;
    const compute = () => {
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const start = vh * 0.78;
      const scrolled = start - rect.top;
      setP(Math.max(0, Math.min(1, scrolled / (rect.height * 0.9))));
    };
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(compute);
    };
    compute();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [ref]);
  return p;
};

const dotColor = (lit, isDecision) => {
  if (!lit) return '#333';
  return isDecision ? '#f5b400' : G;
};

const FlowStep = ({ step, index, lit }) => {
  const isDecision = step.indexOf('Accepted') === 0;
  return (
    <li className="relative">
      <span
        className="absolute -left-8 top-1 w-3.5 h-3.5 rounded-full ring-4 ring-[#0a0a0a] transition-all duration-300"
        style={{ background: dotColor(lit, isDecision), transform: lit ? 'scale(1.15)' : 'scale(1)' }}
      />
      <div className="flex items-center gap-3">
        <span className="text-[11px] font-mono w-6" style={{ color: lit ? G : '#525252' }}>{String(index + 1).padStart(2, '0')}</span>
        <span
          className={`text-sm sm:text-base transition-colors ${lit ? 'text-white' : 'text-neutral-500'} ${isDecision && lit ? 'font-semibold' : ''}`}
          style={isDecision && lit ? { color: '#f5b400' } : undefined}
        >
          {step}
        </span>
      </div>
    </li>
  );
};

export const FlowTimeline = () => {
  const ref = useRef(null);
  const p = useScrollFill(ref);
  const litCount = Math.round(p * projectFlow.length);
  return (
    <div ref={ref} className="relative pl-8">
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/10" />
      <div className="absolute left-[7px] top-2 w-px transition-[height] duration-150 ease-out" style={{ background: G, height: `${Math.min(p, 1) * 100}%` }} />
      <ol className="space-y-7">
        {projectFlow.map((step, i) => (
          <FlowStep key={step} step={step} index={i} lit={i < litCount} />
        ))}
      </ol>
    </div>
  );
};

export default FlowTimeline;
